module.exports = __webpack_public_path__ + "media/images/svg/icon_arrow_right-ffe74fee2ae030652f37214fe5c2e44f.svg";